// extracted by mini-css-extract-plugin
export default {"flex":"header_flex__lvM90","title":"header_title__hT60b"};